import { PlayerControlButtonComponent } from "./PlayerControlButton";

type TIconButtonProps = {
  onClick?: () => void;
  hoverText: string;
  label?: string;
  hidden?: boolean;
  gridArea?: string;
  interactive: boolean;
  Icon: React.ReactNode;

  forceLeft?: boolean;
  forceBottom?: boolean;

  children?: React.ReactNode;
};

const IconButton = ({
  onClick,
  hoverText,
  label,
  hidden,
  gridArea,
  Icon,
  interactive,
  forceBottom,
  forceLeft,
}: TIconButtonProps) => {
  return (
    <PlayerControlButtonComponent
      aria-label={label}
      style={{
        gridArea: gridArea ?? undefined,
      }}
      onClick={onClick}
      hidden={hidden}
      interactive={interactive}
      hoverText={hoverText}
      Icon={Icon}
      forceBottom={forceBottom}
      forceLeft={forceLeft}
    />
  );
};

export default IconButton;
